import { AiQuickTipEnums } from '../../Forms/enums/ai-quick-tip.enum';
import { AiFormatConfigModel } from '../models/AI-helper-dialog-config.model';

export abstract class AbstractAIHelperDialogService {
    abstract getConfig(): AiFormatConfigModel;
    getQuickTipHeader(type: AiQuickTipEnums): string {
        let header;
        switch (type) {
            case AiQuickTipEnums.KEY_MESSAGES:
                header = 'Common.dialog.aiHelper.keyMessages';
                break;
            case AiQuickTipEnums.QUOTES:
                header = 'Common.dialog.aiHelper.quotesHeader';
                break;
        }

        return header;
    }

    getQuickTipHints(type: AiQuickTipEnums): string[] {
        // set text in quick tips
        const hints = [];
        switch (type) {
            case AiQuickTipEnums.KEY_MESSAGES:
                for (let i = 1; i <= 3; i++) {
                    hints.push('Common.dialog.aiHelper.quickTip.messages.hint.' + i);
                }
                break;
            case AiQuickTipEnums.QUOTES:
                for (let i = 1; i <= 4; i++) {
                    hints.push('Common.dialog.aiHelper.quickTip.quotes.hint.' + i);
                }
                break;
        }

        return hints;
    }
}
